import React from "react"
import { Card } from "../../../shared/shared.ui.card"
import { Button } from "../../../shared/shared.ui.button"
import { Loading } from "../../../shared/shared.ui.loading"

import "./index.scss"

const ProjectCard = ({ project, loading, onClick }) => {
  const { title } = project
  return (
    <Card title={title} className="project-card-container">
      {loading ? (
        <Loading />
      ) : (
        <div className="footer-container">
          <Button onClick={onClick} className="fluid">
            Download CSV
          </Button>
        </div>
      )}
    </Card>
  )
}

export default ProjectCard
